
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{staticClass:"cls-1",attrs:{"cx":"57.36","cy":"60.99","r":"44.28"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"57.36","cy":"60.63","r":"33.91"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M43.05 67.47h-.79a11.71 11.71 0 110-23.41 4.23 4.23 0 004.57-2.35c6.53-12.34 18.89-7.48 18.89-7.48C83.85 40.36 77 61.79 77 61.79a13.41 13.41 0 11-22 14.78"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M43.05 67.47a11.71 11.71 0 0011.42 9.12 3.85 3.85 0 00.48 0"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"60.6","cy":"46.52","r":"5.64"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"65.22","cy":"66.63","r":"5.64"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M96.44 93.26l27.71 24.45a6.48 6.48 0 01.38 9.36 6.48 6.48 0 01-9.58-.26L90.74 98.75a1.59 1.59 0 01.11-2.18l3.45-3.27a1.59 1.59 0 012.14-.04z"}}),_c('path',{staticClass:"cls-1",attrs:{"transform":"rotate(-45 90.647 93.423)","d":"M87.72 91.07h5.86v4.72h-5.86z"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"119.67","cy":"122.3","r":"2.13"}})])
          )
        }
      }
    